// Quick and dirty auto width adjustments for input fields
angular.module('wbDirectives').directive('wbAutoWidth', [() => {
  return {
    restrict: 'A',
    link : function($scope, $element, $attrs) {
      var step = +$attrs.wbAutoWidth
      $element.on('input blur', function(event) {
        this.style.width = `${(this.value.length + 1) * step}px`
      })
    }
  }
}]);
